import React from 'react'
import tw from 'tailwind-styled-components'

const TwTh = tw.th`
  pr-32
  pl-16
  font-normal
  border 
  border-t-0 
  border-b-0 
  border-l-0
  border-solid 
  border-main-old
  last:border-r-0  
  whitespace-nowrap
`

export interface Props {
  children?: React.ReactNode
  className?: string
}

export const Title = (props: Props) => {
  const {children, className = ''} = props
  return <TwTh className={className}>{children}</TwTh>
}
